/* eslint-disable max-len */
import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type ConsentsAndDeclarationsModuleSpecsFragment } from '../../../../api/fragments/ConsentsAndDeclarationsModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import ConsentsModuleUpdateForm from './ConsentsModuleUpdateForm';

export type ConsentsModuleUpdateDrawerProps = {
    module: ConsentsAndDeclarationsModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const ConsentsModuleUpdateDrawer = ({ module, onClose, visible }: ConsentsModuleUpdateDrawerProps) => {
    const { t } = useTranslation(['consentsAndDeclarationsModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('consentsAndDeclarationsModuleDetails:updateDrawer.cancelButton')}
                    </Button>
                    <Button form="updateConsentsModule" htmlType="submit" type="primary">
                        {t('consentsAndDeclarationsModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('consentsAndDeclarationsModuleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <ConsentsModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default ConsentsModuleUpdateDrawer;

export const useUpdateConsentsModuleDrawer = (module: ConsentsModuleUpdateDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <ConsentsModuleUpdateDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
